module.exports = __webpack_public_path__ + "img/31.c22225d7.png";